class ViewSharedLayoutPrimary {

    //NOTE: Cannot declare variables at top of class like in Typescript. In plain ES6 JS Microsoft Edge will fail to parse the script (but not other browsers)

    constructor(target) {
        let thisObj = this;
        this.target = target;

        Apfco.disableFormButtonsOnSubmit(this.target);

        this.wrapTrademarkSymbolsWithSuperscriptTag();

        //Set the default focus to the first non-hidden input on all pages with a form. Makes pages easier to fill out with the keyboard
        if (document.getElementsByTagName('form').length > 0) {
            $('form:first *:input[type!=hidden]:first').focus();
        }

        //Apply datatables sort to all bootstrap tables in the site
        $(this.target).find('table.table').each(function () {
            ($(this)).DataTable({
                "paging": false,
                "info": false,
                "searching": false,
                "aaSorting": [] //Make it so Datatables doesn't apply a default sort on page load - https://datatables.net/forums/discussion/1399/how-to-no-sort-by-default
            });
        });

        //Bootstrap v4 - enable tooltips everwhere: https://getbootstrap.com/docs/4.0/components/tooltips/
        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        })

        console.log('LayoutPrimary Initialized');
    }

    wrapTrademarkSymbolsWithSuperscriptTag() {
        //Wrap all registered trademark symbols with <sup>, as it applies to almost every design mockup we receive - see here https://stackoverflow.com/questions/19364581/adding-superscript-sup-tags-around-all-trademark-and-registered-trademark-symb
        let regexp = /[\xAE]/;
        $('body :not(script,sup)').contents().filter(function () {
            return this.nodeType === 3 && (regexp.test(this.nodeValue));
        }).replaceWith(function () {
            return this.nodeValue.replace(regexp, '<sup>$&</sup>');
        });
        $('body :not(script,sup)').contents().filter(function () {
            return this.nodeType === 3;
        }).replaceWith(function () {
            return this.nodeValue.replace(/[™®]/g, '<sup>$&</sup>');
        });
    }
}

//On page load, take all found elements with the classname and create objects for them to initialize
let ViewSharedLayoutPrimaryList = [];
$(function () {
    let elementsByClass = document.getElementsByClassName("LayoutPrimary");
    for (let i = 0; i < elementsByClass.length; i++) {
        ViewSharedLayoutPrimaryList.push(new ViewSharedLayoutPrimary(elementsByClass.item(i)));
    };
});